module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "head"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Acknowledgments#page_xii"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction#page_xiv"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Introduction")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_1_Preparing_the_Soil#page_1"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style1"
  }, [_vm._v("1")]), _vm._v("Preparing the Soil")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter_2_Weeds_in_the_Crop#page_7"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style1"
  }, [_vm._v("2")]), _vm._v("Weeds in the Crop")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_3_Wind_and_Hail#page_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style1"
  }, [_vm._v("3")]), _vm._v("Wind and Hail")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_4_Seeds_of_Change#page_26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style1"
  }, [_vm._v("4")]), _vm._v("Seeds of Change")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_5_Deeper_Roots#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style1"
  }, [_vm._v("5")]), _vm._v("Deeper Roots")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_6_A_New_Road#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style1"
  }, [_vm._v("6")]), _vm._v("A New Road")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_7_New_Growth#page_47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style1"
  }, [_vm._v("7")]), _vm._v("New Growth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_8_Ripening#page_63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style1"
  }, [_vm._v("8")]), _vm._v("Ripening")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_9_Branching_Out#page_73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style1"
  }, [_vm._v("9")]), _vm._v("Branching Out")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_10_Nurturing_Each_Other#page_87",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style"
  }, [_vm._v("10")]), _vm._v("Nurturing Each Other")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Photo_Collection_I#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Photo Collection I")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_11_Fruitfulness#page_105",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style"
  }, [_vm._v("11")]), _vm._v("Fruitfulness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_12_Growing_With_Grace#page_113",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style"
  }, [_vm._v("12")]), _vm._v("Growing With Grace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter_13_New_Harvest#page_123",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style"
  }, [_vm._v("13")]), _vm._v("New Harvest")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter_14_Propagation#page_136",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style"
  }, [_vm._v("14")]), _vm._v("Propagation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter_15_Nurturing_the_Seedlin#page_150",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style"
  }, [_vm._v("15")]), _vm._v("Nurturing the Seedlings")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter_16_Some_Sow__Others_Reap#page_158",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style"
  }, [_vm._v("16")]), _vm._v("Some Sow, Others Reap")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter_17_Rain_and_Sunshine#page_167",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style"
  }, [_vm._v("17")]), _vm._v("Rain and Sunshine")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_18_Storms#page_174",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style"
  }, [_vm._v("18")]), _vm._v("Storms")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_19_Bountiful_Blessings#page_181",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style"
  }, [_vm._v("19")]), _vm._v("Bountiful Blessings")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_20_Future_Growth#page_192",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "style"
  }, [_vm._v("20")]), _vm._v("Future Growth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Photo_Collection_II#page_197",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Photo Collection II")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/31_About_the_Authors#page_207",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("About the Authors")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Endnotes#page_209",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Endnotes")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2298b851","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Contents.vue
// module id = 75
// module chunks = 0